import { apiGet } from '../../api'

export const get_all_surveys = query => {
  return apiGet({
    endpoint: `stoplight/all_surveys`
  })
}
